export const enum ObjectSuperTypesEnum {
    Seat = "seat",
    Row = "row",
    Table = "table",
    EmptySpace = "emptySpace",
    RoundTable = "roundTable",
    RectTable = "rectTable",
    PolygonZone = "polygonZone"
}
